export interface DistrictNameSource {
  district_id: number;
  district_name?: string | null;
}

export interface DistrictOption {
  district_id: number;
  district_name: string;
}

/**
 * District label for a church row: the name sent with the church (covers inactive districts),
 * then the loaded districts list, then an em dash.
 */
export function resolveDistrictName(church: DistrictNameSource, districts: DistrictOption[]): string {
  const fromChurch = church.district_name?.trim();
  if (fromChurch) return fromChurch;
  const fromList = districts.find((district) => district.district_id === church.district_id)?.district_name?.trim();
  return fromList || '\u2014';
}
